import React from "react";
import { MessageSquare } from "lucide-react";
const messages = [{
  title: "Casual Connection",
  subject: "Hey! Loved your thoughts on [Topic]",
  content: "Hi [Name]! Just saw your post about [topic] and totally agree with what you said about [specific point]. Btw, have you heard about ",
  link: "[company]",
  contentAfterLink: "? Been using it for a while and it's pretty great for [specific use case]. What tools are you using these days? Always curious to discover new stuff!"
}, {
  title: "Industry Chat",
  subject: "Quick question about [Industry] tools",
  content: "Hey [Name]! Been following your updates on [industry topic] – really interesting stuff! I've been exploring different solutions lately and came across ",
  link: "[company]",
  contentAfterLink: ". Found it super useful for [specific benefit]. What's your go-to stack? Would love to compare notes!"
}];
export const MessageExamples = () => {
  return <section className="w-full bg-white py-16" data-id="element-63">
      <div className="max-w-4xl mx-auto px-4" data-id="element-64">
        <div className="text-center mb-12" data-id="element-65">
          <h2 className="text-3xl font-bold mb-4" data-id="element-66">
            Example Connection Messages
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-67">
            Here are examples of the type of personalized, value-adding messages
            we'll send to grow your network
          </p>
        </div>
        <div className="space-y-8" data-id="element-68">
          {messages.map((message, index) => <div key={index} className="bg-white rounded-lg border shadow-sm overflow-hidden" data-id="element-69">
              <div className="border-b bg-gray-50 p-4" data-id="element-70">
                <div className="flex items-center space-x-2 text-emerald-600 mb-2" data-id="element-71">
                  <MessageSquare className="h-5 w-5" data-id="element-72" />
                  <h3 className="font-semibold" data-id="element-73">{message.title}</h3>
                </div>
                <div className="font-medium text-gray-900" data-id="element-74">
                  Subject: {message.subject}
                </div>
              </div>
              <div className="p-4" data-id="element-75">
                <div className="text-gray-600 whitespace-pre-line" data-id="element-76">
                  {message.content}
                  <a href="#" target="_blank" rel="noopener noreferrer" className="text-emerald-600 hover:text-emerald-700 hover:underline" data-id="element-77">
                    {message.link}
                  </a>
                  {message.contentAfterLink}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};